import BaseViewModel from '../Models/BaseViewModel';
import { PathUtil } from './Utils/PathUtil';
import ViewModelDataCollector from './ViewModelDataCollector';

class EnumWrapper {
	EnumId: string;
	EnumValue: string;
	EnumTitle: string;
	DataObject: EnumWrapper;

	constructor(viewModel: any, id: string) {
		this.EnumValue = id;
		this.EnumId = id;
		this.EnumTitle = (viewModel.options.filter((item: any) => {
			return item.LV === id;
		}) || {})[0].DA;
		this.DataObject = this;
	}

	toString = () => {
		return this.EnumTitle;
	};
	ToString = () => {
		return this.EnumTitle;
	};
}

class WrappersFactory {
	GetValue = (element: any) => {
		if (element?.selectedValueS2) {
			if (
				element.elementDescriptor.DescriptorKey ===
					'EnumControlDescriptor' &&
				element.elementDescriptor.IsSave
			) {
				const value = element.selectedValueS2;
				if (value) {
					if (element.multiflag && value.length) {
						return value.map((item: any) => {
							return new EnumWrapper(element, item);
						});
					}
					return new EnumWrapper(element, value);
				}
				return null;
			}
			return element.selectedValueS2;
		} else {
			if (
				element.elementDescriptor.DescriptorKey ===
				'DateControlDescriptor'
			) {
				return this.getWrapedDate(element);
			}
			if (
				['FiasRegionSelectControlViewModel', 'FIAS'].includes(
					element.elementDescriptor.DescriptorKey,
				)
			) {
				return this.getWrapedFias(element);
			}
			if (
				element.elementDescriptor.DescriptorKey ===
				'CollectionFormDescriptor'
			) {
				return this.getWrapedCollection(element);
			}
			if (element.elementDescriptor.DescriptorKey === 'CustomerSelect') {
				return this.getWrapedCustomer(element);
			}
			return element.getValue();
		}
	};

	getFormData = (element: any) => {
		return ViewModelDataCollector.collectCurrentElementDataFromKoVm(
			element,
		);
	};

	getWrapedCollection = (element: any) => {
		const col = element.CollectionItems.map((x: any) => {
			return this.getFormData(x);
		});

		col.Count = col.length;
		return col;
	};

	getWrapedDate = function (element: any) {
		const dateStr = element.getValue();
		let date = null;
		try {
			if (dateStr != null && dateStr !== '') {
				const parts = dateStr.split('.');
				date = new Date(parts[2], parts[1] - 1, parts[0]);
			}
		} catch (e) {
			console.error("can't parse date correctly");
		}
		return date && isNaN(date.getTime()) ? null : date;
	};

	getWrapedFias = function (viewModel: any) {
		const value = viewModel.getValue();
		if (value) {
			const toStr = function () {
				return value.FullAddress;
			};
			value.toString = toStr;
			value.ToString = toStr;

			if (value.DataObject == null) {
				value.DataObject = value;
			}
		}
		return value;
	};

	getWrapedCustomer = function (viewModel: any) {
		const value = viewModel.getValue();
		if (value) {
			const toStr = function () {
				return value.DisplayName;
			};
			value.toString = toStr;
			value.ToString = toStr;

			if (value.DataObject == null) {
				value.DataObject = value;
			}
		}
		return value;
	};
}

export class HostObject {
	wrappersFactory: any;
	contextElement: BaseViewModel;
	FormObject: any;

	constructor(contextElement: BaseViewModel) {
		this.wrappersFactory = new WrappersFactory();
		this.contextElement = contextElement;
		this.FormObject = contextElement.FormObject;
	}

	getViewModelForPath = (path: string): BaseViewModel => {
		const absolutePath = PathUtil.toAbsolutePath(
			path,
			this.contextElement.FullPath,
		);
		const element = BaseViewModel.EntityPathToViewModel[absolutePath];
		if (element) {
			return element;
		}
		// Пути из дескрипторов могут содержать префикс "_.", хотя в EntityPathToViewModel они зарегистрированы без него
		if (absolutePath.startsWith('_.')) {
			return BaseViewModel.EntityPathToViewModel[absolutePath.slice(2)];
		}
		return element;
	};

	logNotFoundByPathError = (path: string) => {
		console.warn('can not find element by path', path);
		console.warn('contextElement path', this.contextElement.FullPath);
	};

	/** Получене значения элемента по пути. */
	GetValue = (path: string): any => {
		const element = this.getViewModelForPath(path);
		if (!element) {
			this.logNotFoundByPathError(path);
			return null;
		}
		return this.wrappersFactory.GetValue(element);
	};

	/**
	 * Метод для использования с коллекциями
	 * сигнатура - hostObject.GetColItemValue("~coll1", i, "e1.l", j, "s")
	 * @param args
	 * @returns Прочитанное значение.
	 */
	GetColItemValue = (...args: any) => {
		let localPath = '';
		for (let i = 0; i < args.length; i++) {
			const split = args[i];
			localPath += i % 2 === 1 ? '[' + split + '].' : split;
		}
		return this.GetValue(localPath);
	};

	/** Получение переменной контекста формы */
	GetContextVariable = (key: string) => {
		if (BaseViewModel.formContextData) {
			return BaseViewModel.formContextData[key];
		}
		return null;
	};

	/** Установка значения элемента по пути. */
	SetValue = (path: string, value: any) => {
		const element = this.getViewModelForPath(path);
		if (!element) {
			this.logNotFoundByPathError(path);
			return;
		}
		element.Value = value;
	};
}
